<cft-progressive-disclosure-box
  *transloco="let t"
  [heading]="t('startJobProgressiveDisclosure.heading')"
  [subHeading]="offering.title"
  [buttonText]="t('startJobProgressiveDisclosure.buttonText')"
  (buttonClicked)="startRequest()"
  class="max-w-[400px]"
>
  <fa-icon [icon]="headingIcon" content="icon" class="text-green-500"></fa-icon>
  <img
    [ngSrc]="'https://www.buildigo.ch/assets/images/buildigo.svg'"
    alt="Logo"
    width="126"
    height="30"
    content="logo"
  />
  <ng-container content="form" [formGroup]="form">
    @if (intentionItems.length) {
      <cft-form-field>
        <label for="needs">
          {{ t('startJobProgressiveDisclosure.needsLabel') }}
        </label>
        <cft-select id="needs" [items]="intentionItems" [formControl]="intentionsControl"></cft-select>
      </cft-form-field>
    }
    <cft-form-field>
      <label for="expectations">
        {{ t('startJobProgressiveDisclosure.expectationsLabel') }}
      </label>
      <cft-select id="expectations" [items]="expectations" [formControl]="expectationsControl"></cft-select>
    </cft-form-field>
  </ng-container>
  <ng-container content="foot-note">
    <fa-icon [icon]="lockIcon"></fa-icon>&nbsp;
    <a class="bold cursor-pointer underline" [routerLink]="happinessGuaranteeLink" bgoOpenNewTab>
      {{ t('startJobProgressiveDisclosure.footer.link') }}
    </a>
    {{ t('startJobProgressiveDisclosure.footer.text') }}
  </ng-container>
</cft-progressive-disclosure-box>
